export default "__VITE_ASSET__B2IzipV1__"